/* Histoires Magiques — carrousel témoignages */
(function(){
  document.querySelectorAll('[data-hm-carrousel]').forEach(function(env){
    var c = env.querySelector('.hm-carrousel');
    if(!c) return;

    // Flèches (ordinateur)
    env.querySelectorAll('.hm-carrousel-fleche').forEach(function(btn){
      btn.addEventListener('click', function(){
        var carte = c.children[0];
        var pas = carte ? carte.getBoundingClientRect().width + 18 : 300;
        c.scrollBy({left: pas * Number(btn.dataset.dir), behavior:'smooth'});
      });
    });

    // Glisser à la souris (ordinateur)
    var actif=false, depX=0, depScroll=0, aBouge=false;
    c.addEventListener('pointerdown', function(e){
      if(e.pointerType !== 'mouse') return;
      actif=true; aBouge=false; depX=e.clientX; depScroll=c.scrollLeft;
    });
    window.addEventListener('pointermove', function(e){
      if(!actif) return;
      var delta = e.clientX - depX;
      if(Math.abs(delta) > 5){ aBouge=true; c.classList.add('hm-saisi'); }
      c.scrollLeft = depScroll - delta;
    });
    window.addEventListener('pointerup', function(){
      actif=false;
      requestAnimationFrame(function(){ c.classList.remove('hm-saisi'); });
    });
    c.addEventListener('click', function(e){
      if(aBouge){ e.preventDefault(); aBouge=false; }
    }, true);

    // Points synchronisés
    var points = env.parentElement.querySelectorAll('.hm-carrousel-points span');
    if(points.length){
      c.addEventListener('scroll', function(){
        var ratio = c.scrollLeft / (c.scrollWidth - c.clientWidth || 1);
        var idx = Math.min(points.length - 1, Math.round(ratio * (points.length - 1)));
        points.forEach(function(p,i){ p.classList.toggle('hm-actif', i === idx); });
      }, {passive:true});
    }
  });
})();
